import { ApolloClient, InMemoryCache, HttpLink, split } from "@apollo/client";
import { getMainDefinition } from "@apollo/client/utilities";
import { GraphQLWsLink } from "@apollo/client/link/subscriptions";
import { createClient } from "graphql-ws";

const {
    REACT_APP_HASURA_URL,
    REACT_APP_HASURA_ADMIN_SECRET,
    REACT_APP_HASURA_WS
} = process.env;

// Crear el enlace HTTP
const httpLink = new HttpLink({
    uri: REACT_APP_HASURA_URL,
    headers: {
        "x-hasura-admin-secret": REACT_APP_HASURA_ADMIN_SECRET || ""
    },
});

// Crear el enlace WS, que se conectará al servidor de Hasura
const wsLink = new GraphQLWsLink(
    createClient({
        url: REACT_APP_HASURA_WS || "",
        connectionParams: {
            headers: {
                "x-hasura-admin-secret": REACT_APP_HASURA_ADMIN_SECRET || "",
            },
        },
    })
);

// Crear un enlace dividido que seleccionará entre el enlace WS y el enlace HTTP
const splitLink = split(
    ({ query }) => {
        const definition = getMainDefinition(query);
        // Si la definición es una operación de suscripción, usar el enlace WS
        return (
            definition.kind === 'OperationDefinition' &&
            definition.operation === 'subscription'
        );
    },
    wsLink,
    httpLink,
);

// Crear el cliente de Apollo
const client = new ApolloClient({
    link: splitLink,
    cache: new InMemoryCache(), // Usar una caché en memoria
});

export default client;
